import React, { useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Container, Col, Card, CardBody } from "reactstrap";

import { useDispatch } from "react-redux";
import Loading from "../../Components/Loading";
import EmployeesTable from "../../Components/Tables/EmployeesTable/EmployeesTable";
import { getRolesForTables } from "../../slices/admin/thunk";
import { useCurrentUser } from "../../slices/auth/hooks";
import { DASHBOARD_USER_ROLES } from "../../constants";
import EditEmployeeModal from "../../Components/modals/EmployeesModal/EditEmployeeModal";
import { getStatusEmployees } from "../../utils/utils";
import NavTabEmployee from "../../Components/Tabs/NavTabEmployee";
import SearchBar from "../../Components/SearchBar/SearchBar";
import employeesIcon from "../../assets/images/iconsRoles/employeesIcon.svg";
import HeadersRole from "../../Components/Headers/HeadersRole";

const DashboardGaEmployees = () => {
  const inputRef = useRef(null);
  const currentUser = useCurrentUser();
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);

  const [employees, setEmployees] = useState([]);
  const [totalEmployees, setTotalEmployees] = useState(0);
  const [pageSize, setPageSize] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const [activeTab, setActiveTab] = useState("1");
  const [currentPage, setCurrentPage] = useState(0);

  const [isTerminated, setIsTerminated] = useState(false);
  const [isPending, setIsPending] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState(searchTerm);
  const [searchDone, setSearchDone] = useState(false);
  const [lastSearchTerm, setLastSearchTerm] = useState(searchTerm);

  const toggleTab = (tab, status) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setIsTerminated(status === "terminated");
      setIsPending(status === "pending");
      setCurrentPage(0);
    }
  };

  const handleChangePage = (page) => {
    setCurrentPage(page);
  };

  useEffect(() => {
    const timerId = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 500);

    return () => clearTimeout(timerId);
  }, [searchTerm]);

  const fetchEmployees = async () => {
    try {
      setLoading(true);
      const employeeStatus = getStatusEmployees(isTerminated, isPending);
      const response = await dispatch(
        getRolesForTables({
          id: currentUser.id,
          userRole: DASHBOARD_USER_ROLES.GA,
          role: "employees",
          status: employeeStatus,
          page: currentPage,
          query: searchTerm,
        })
      ).unwrap();
      setEmployees(response.data);
      setTotalEmployees(response.total);
      setPageSize(response.pageSize);
      setTotalPages(response.pages);
      setSearchDone(true);
      setLoading(false);
    } catch (error) {
      setLoading(true);
      console.log(error);
      setLoading(false);
    }
  };
  useEffect(() => {
    if (debouncedSearchTerm === lastSearchTerm) {
      setSearchDone(true);
    } else {
      setSearchDone(false);
    }
    fetchEmployees();
  }, [
    isTerminated,
    isPending,
    currentPage,
    debouncedSearchTerm,
    currentUser.id,
    dispatch,
  ]);

  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState({});

  const hanldeRefreshTable = () => {
    fetchEmployees();
  };

  const handleEditClick = (employee) => {
    setSelectedEmployee(employee);
    setIsEditModalOpen(true);
  };

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
  };

  return (
    <React.Fragment>
      <EditEmployeeModal
        open={isEditModalOpen}
        setOpen={setIsEditModalOpen}
        editUser={selectedEmployee}
        setUser={setSelectedEmployee}
        onRefreshTable={hanldeRefreshTable}
      />
      <div className="page-content px-0 ">
        <Container fluid>
          <HeadersRole
            role={"Employees"}
            icon={employeesIcon}
            svg={true}
            text=""
          />
          <Card className="mb-4 pb-3">
            <CardBody>
              <div className="col-12 d-flex justify-content-between  align-items-center ">
                <div className="col-4 d-flex justify-content-end">
                  <SearchBar
                    inputRef={inputRef}
                    value={searchTerm}
                    onChange={handleSearch}
                    placeholder="Filter by name or email"
                    shouldDisplaySearchBar={true}
                  />
                </div>
              </div>

              <Col xl={12}>
                <NavTabEmployee
                  loading={loading}
                  activeTab={activeTab}
                  toggleTab={toggleTab}
                />
                <div className="table-container  position-relative">
                  {loading && <Loading />}
                  <div className="live-preview">
                    <div className="table-responsive ">
                      <EmployeesTable
                        activeTab={activeTab}
                        data={employees}
                        searchDone={searchDone}
                        searchParam={debouncedSearchTerm}
                        onRefreshTable={hanldeRefreshTable}
                        onEditClick={handleEditClick}
                        shouldShowImportMessage={false}
                        paginationProps={{
                          itemsCount: employees.length,
                          totalPages: totalPages,
                          totalItems: totalEmployees,
                          currentPage: currentPage,
                          onChangePage: handleChangePage,
                        }}
                        isTerminated={isTerminated}
                      />
                    </div>
                  </div>
                </div>
              </Col>
            </CardBody>
          </Card>
        </Container>
      </div>
      <div id="portal-root"></div>
    </React.Fragment>
  );
};

export default DashboardGaEmployees;
